import { render, staticRenderFns } from "./interim-report-per-location.vue?vue&type=template&id=37c486e3&"
import script from "./interim-report-per-location.vue?vue&type=script&lang=js&"
export * from "./interim-report-per-location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports